// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"imageThumbnail_placeholder__V2e0U","thumbnail":"imageThumbnail_thumbnail__1VVSy","text":"imageThumbnail_text__1wntp"};